import ApiClient from '../ApiClient';

// Registro de ferramenta externa da conta (Studio > Ferramentas personalizadas).
// CRUD account-scoped contra /api/v1/accounts/:account_id/ai/external_tools.
//
// A definição mora aqui, UMA vez por conta; o agente vincula por referência
// (`external_tool_ids` no update do agente). É neste registro que ficam as
// declarações que sustentam a idempotência (`tool_class`, `idempotency_scope`,
// `verify_tool_id`) e o gate de quem dispara (`usage`) — copiadas por agente,
// a mesma ferramenta podia ter garantias diferentes em cada um.
class StudioExternalTool extends ApiClient {
  constructor() {
    super('ai/external_tools', { accountScoped: true });
  }
}

export default new StudioExternalTool();
